class ClicksCounter {
    clicks = 0;
    addClick()
    {
        this.clicks += 1;
    }
    reset()
    {
        this.clicks = 0;
    }
}

export default new ClicksCounter();